/**
 * Goal categories — 5S coaching model + Body Comp.
 *
 * Strength / Speed → search the coach's exercise library
 * (live results from /api/athlete/goals/exercise-search).
 *
 * Stamina / Suppleness / Skill / Body Comp → curated suggestions or free-form,
 * since the exercise library doesn't track those today.
 */
export const GOAL_CATEGORIES = [
  {
    id: "strength",
    label: "Strength",
    icon: "🏋️",
    description: "Force production — 1RM / top sets / Olympic lifts",
    source: "library",
    suggestions: [
      { name: "Bench Press", unit: "lbs", direction: "up" },
      { name: "Back Squat", unit: "lbs", direction: "up" },
      { name: "Deadlift", unit: "lbs", direction: "up" },
      { name: "Power Clean", unit: "lbs", direction: "up" },
      { name: "Overhead Press", unit: "lbs", direction: "up" },
    ],
  },
  {
    id: "speed",
    label: "Speed",
    icon: "⚡",
    description: "Sprints, jumps, agility — speed-strength",
    source: "library",
    suggestions: [
      { name: "40-yard Sprint", unit: "sec", direction: "down" },
      { name: "10-yard Sprint", unit: "sec", direction: "down" },
      { name: "Vertical Jump", unit: "in", direction: "up" },
      { name: "Standing Broad Jump", unit: "in", direction: "up" },
      { name: "Pro Agility (5-10-5)", unit: "sec", direction: "down" },
    ],
  },
  {
    id: "stamina",
    label: "Stamina",
    icon: "🏃",
    description: "Aerobic + anaerobic endurance",
    source: "static",
    suggestions: [
      { name: "Mile Run", unit: "sec", direction: "down" },
      { name: "1.5-Mile Run", unit: "sec", direction: "down" },
      { name: "2-Mile Run", unit: "sec", direction: "down" },
      { name: "800m Run", unit: "sec", direction: "down" },
      { name: "5K Run", unit: "sec", direction: "down" },
      { name: "Plank Hold", unit: "sec", direction: "up" },
      { name: "Wall Sit", unit: "sec", direction: "up" },
      { name: "Dead Hang", unit: "sec", direction: "up" },
      { name: "Burpees in 5 min", unit: "reps", direction: "up" },
    ],
  },
  {
    id: "suppleness",
    label: "Suppleness",
    icon: "🧘",
    description: "Flexibility & mobility",
    source: "static",
    suggestions: [
      { name: "Sit & Reach", unit: "in", direction: "up" },
      { name: "Shoulder Mobility", unit: "in", direction: "down" },
      { name: "Hip Internal Rotation", unit: "deg", direction: "up" },
      { name: "Ankle Dorsiflexion (R)", unit: "deg", direction: "up" },
      { name: "Ankle Dorsiflexion (L)", unit: "deg", direction: "up" },
      { name: "Pancake Stretch", unit: "in", direction: "down" },
      { name: "Front Splits", unit: "in", direction: "down" },
    ],
  },
  {
    id: "skill",
    label: "Skill",
    icon: "🎯",
    description: "Sport-specific abilities",
    source: "static",
    suggestions: [
      { name: "Free Throws (out of 10)", unit: "made", direction: "up" },
      { name: "3-Pointers (out of 10)", unit: "made", direction: "up" },
      { name: "Pull-ups (max reps)", unit: "reps", direction: "up" },
      { name: "Push-ups (max reps)", unit: "reps", direction: "up" },
      { name: "Juggling Streak", unit: "reps", direction: "up" },
      { name: "Throwing Distance", unit: "ft", direction: "up" },
    ],
  },
  {
    id: "body_comp",
    label: "Body Comp",
    icon: "⚖️",
    description: "Bodyweight, body fat",
    source: "static",
    suggestions: [
      { name: "Bodyweight (cut)", unit: "lbs", direction: "down" },
      { name: "Bodyweight (gain)", unit: "lbs", direction: "up" },
      { name: "Body Fat %", unit: "%", direction: "down" },
      { name: "Lean Mass", unit: "lbs", direction: "up" },
      { name: "Waist Measurement", unit: "in", direction: "down" },
    ],
  },
];

export const findCategory = (id) => GOAL_CATEGORIES.find((c) => c.id === id);
